const defaultCulture = 'en-GB'
export function getCurrentCulture () {
  return document.querySelector('html')?.dataset?.culture ?? defaultCulture
}
